import { pickingReportActions } from './pickingReportActions'
import { usePickingReport } from '../Context/usePickingReport'
import { PickingItemProps } from '../screens/PickingStatesSquare/interfaces'
import { apiCall, ApiConfig } from '../../../config/api'
import { PickingReportItems, SnackBar } from '../types/reducerTypes'
import { PickingSquareTitles, tipoInforme } from '../const/pickingReportConst'
import { DateTime } from 'luxon'
import { localDate, localDateFromInput } from '../../../utils/dateHelper'

/*
Copyright 2022-06-08 por Jorge Parrado Ecomsur Holding S.A ©
Detalle: Crea logica de negocio reporte de picking
*/

export const PickingReportBusiness = () => {
  const {
    setIsShowRoutes,
    setSelectPickingState,
    setSelectedZone,
    setFilteredDate,
    setPickingItems,
    setCardsItems,
    setSnackbar,
    setPickingDetailItems,
    setLoading
  } = pickingReportActions()
  const { state, dispatch } = usePickingReport()

  const handleSetSnackbar = (value: SnackBar) => dispatch(setSnackbar(value))

  const handleSetIsShowRoutes = (value: boolean) =>
    dispatch(setIsShowRoutes(value))

  const handlesetCardsItems = (value: PickingItemProps[]) =>
    dispatch(setCardsItems(value))

  const handleSetPickingItems = (value: PickingReportItems[]) =>
    dispatch(setPickingItems(value))

  const handleSelectPickingState = (value: PickingItemProps) => {
    dispatch(setSelectPickingState(value))
    handleSetIsShowRoutes(true)
  }

  const handleSelectZone = (value: number) => dispatch(setSelectedZone(value))

  const handleChangeFilteredDate = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => dispatch(setFilteredDate(e.target.value))

  const getSearch = () => {
    let deliveryDate = ''
    switch (state.btnType) {
      case 1:
        deliveryDate = `&DeliveryDate=${localDateFromInput(state.filteredDate)}`
        break
      case 2:
        deliveryDate = `&DeliveryDate=${localDate()}`
        break
      default:
        deliveryDate = ''
    }

    const zoneId = state.selectedZone > 0 ? `&ZoneId=${state.selectedZone}` : ''

    apiCall(
      'GET',
      `${ApiConfig.PickingDashboard}?dateType=${state.btnType}${zoneId}${deliveryDate}`
    )
      .then((resp) => {
        if (resp.data.length > 0 && resp.status === 200) {
          handleSetPickingItems(resp.data)
          handlesetCardsItems(mapperPickingCards(resp.data))
        }

        if (resp.data.length === 0 && resp.status === 200) {
          handleSetSnackbar({
            message: tipoInforme.filter((x) => x.id === state.btnType)[0].name,
            open: true,
            status: 'success'
          })
          handleSetPickingItems([])
          handlesetCardsItems([])
        }
      })
      .catch(({ data: { message } }) => {
        handleSetSnackbar({ message, open: true, status: 'error' })
        handleResetData()
      })
      .finally(() => {
        dispatch(setLoading(false))
        dispatch(setPickingDetailItems([]))
      })
  }

  const mapperId = (value: PickingReportItems): number => {
    if (value.validationStatusId === 0) {
      return value.pickingRouteStateId
    }
    if (value.validationStatusId === 2) {
      return 4
    }
    if (value.validationStatusId === 3) {
      return 5
    }
    return value.pickingRouteStateId
  }

  const mapperIdToValidationStatus = (
    value: PickingItemProps
  ): number | null => {
    let validationStatusId = 0
    if (value.id === 4) {
      validationStatusId = 2
    }
    if (value.id === 5) {
      validationStatusId = 3
    }
    return validationStatusId
  }

  const mapperPickingCards = (
    items: PickingReportItems[]
  ): PickingItemProps[] => {
    let cardItems: PickingItemProps[] = []
    if (items.length === 0) {
      return []
    }

    cardItems = items.map((item) => ({
      qty: item.qty,
      title:
        PickingSquareTitles.find(
          (title) =>
            title.id === item.pickingRouteStateId &&
            title.subId === item.validationStatusId
        )?.title || '',
      id: mapperId(item),
      height: `${
        (item.qty /
          items.reduce((prev, currentValue) => prev + currentValue.qty, 0)) *
        100 *
        4
      }%`
    }))

    return state.btnType == 3 ? cardItems.filter((x) => x.id != 5) : cardItems
  }

  const getSearchDetail = (value: PickingItemProps) => {
    handleSelectPickingState(value)
    dispatch(setLoading(true))
    const pickingStateId = value.id > 3 ? 3 : value.id
    const pickingRouteStateId = `&PickingRouteStateId=${pickingStateId}`

    const validationId = mapperIdToValidationStatus(value)
    const validationStatusId = `&ValidationStatusId=${validationId}`

    const deliveryDate =
      state.btnType === 1
        ? `&DeliveryDate=${DateTime.fromISO(`${state.filteredDate}T00:00:00`)
            .toUTC()
            .toFormat("yyyy-MM-dd'T'HH:mm:ss")}`
        : ''

    const zoneId = state.selectedZone > 0 ? `&ZoneId=${state.selectedZone}` : ''

    apiCall(
      'GET',
      `${ApiConfig.PickingDashboard}/GetPickingRouteDetail?dateType=${state.btnType}${zoneId}${deliveryDate}${pickingRouteStateId}${validationStatusId}`
    )
      .then((resp) => {
        dispatch(setPickingDetailItems(resp.data))
      })

      .catch(({ data: { message } }) =>
        handleSetSnackbar({ message, open: true, status: 'error' })
      )
      .finally(() => dispatch(setLoading(false)))
  }

  const handleResetData = () => {
    handleSetPickingItems([])
    handlesetCardsItems(mapperPickingCards([]))
    handleSetIsShowRoutes(false)
    dispatch(setPickingDetailItems([]))
  }

  return {
    handleSetIsShowRoutes,
    handleSelectPickingState,
    handleSelectZone,
    handleChangeFilteredDate,
    getSearch,
    handleSetPickingItems,
    mapperPickingCards,
    handlesetCardsItems,
    getSearchDetail,
    handleSetSnackbar
  }
}
